import { createSlice } from '@reduxjs/toolkit';
import { getProjectParameters } from 'ducks/project-parameters/operators';
import { normalizeAndSortProjectParameters } from 'ducks/project-parameters/utils';
import { Slices } from 'ducks/slices';
import { ProjectParameters } from 'ducks/types/store-types';

export interface ProjectParametersState {
  project_parameters: ProjectParameters;
  notification: boolean;
}

const initialState: ProjectParametersState = {
  project_parameters: [],
  notification: false,
};

const projectParametersSlice = createSlice({
  name: Slices.PROJECT_PARAMETERS,
  initialState,
  reducers: {
    clearProjectParameters: () => {
      return initialState;
    },
    setNotification: (state, action) => {
      return { ...state, notification: action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProjectParameters.pending, () => {
        return initialState;
      })
      .addCase(getProjectParameters.fulfilled, (state, { payload }) => {
        state.project_parameters = normalizeAndSortProjectParameters(payload);
      })
      .addCase(getProjectParameters.rejected, () => {
        return initialState;
      });
  },
});

export const { clearProjectParameters, setNotification } = projectParametersSlice.actions;

export default projectParametersSlice.reducer;
